import axios from 'axios'
import { API_NAME, generateApiConfig } from '@/config'
import {
  requestSuccess,
  requestFail,
  responseSuccess,
  responseFail
} from '@/service/fetch/interceptors'

let allAxiosInstance = {}
API_NAME.forEach(name => {
  const axiosInstance = axios.create(generateApiConfig(name))
  axiosInstance.interceptors.request.use(requestSuccess, requestFail)
  axiosInstance.interceptors.response.use(responseSuccess, responseFail)
  allAxiosInstance[name] = axiosInstance
})
export { allAxiosInstance }
